var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNextCerulean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.815h10.496l-2.651-2.66L8.889.112l4.445 4.445L8.889 9 7.845 7.956l2.651-2.66H0V3.816z",
    fill: "#1056FB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjAwMDE2MzA3OCAzLjgxNTAzSDEwLjQ5NjVMNy44NDQ2MSAxLjE1NTc3TDguODg5MDUgMC4xMTEzMjhMMTMuMzMzNSA0LjU1NTc3TDguODg5MDUgOS4wMDAyMkw3Ljg0NDYxIDcuOTU1NzdMMTAuNDk2NSA1LjI5NjUxSDAuMDAwMTYzMDc4VjMuODE1MDNaIiBmaWxsPSIjMTA1NkZCIi8+Cjwvc3ZnPgo=";
export { SvgArrowNextCerulean as ReactComponent };